// translation.js
export const translations = {
  en: {
    // header$footer
    selectCurrency: "Select Currency",
    selectOption: "Select...",
    propertyImages: "Property Images",
    selectCity: "Select City",
    home: "Home",
    hotOffers: "Hot Offers",
    featured: "Featured Properties",
    featured1: "Featured",
    luxury: "Luxury Property",
    articles: "Articles",
    toggleLang: "عربي",
    properties: "Properties",
    developers: "Developers",
    contactUs: "Contact Us",
    companyInfo: "Company Info",
    quickLinks: "Quick Links",
    newsletter: "Newsletter",
    yourEmail: "Your email",
    subscribe: "Subscribe",
    newsLetterDescription:
      "Subscribe to our newsletter for updates and exclusive offers.",
    footerDescription:
      " Your trusted partner in finding the perfect property in Egypt's most prestigious locations.",
    allRightsReserved:"Real Estate. All rights reserved.",
    address: "Fifth Settlement, Nourth Teseen",
    //about component
    poweredBy: "Powered by",
    aboutTitle: "Our Values & Mission",
    aboutDescription:
      "We are committed to transforming the real estate brokerage experience by connecting clients with exceptional properties and opportunities that align with their dreams and goals. Guided by integrity, we build trust through transparency, honesty, and accountability in every transaction.",
    propertiesCount: "Properties",
    clientsCount: "Clients",
    excellenceTitle: "Excellence",
    excellenceText:
      "Delivering exceptional service and premium properties to exceed expectations.",
    trustTitle: "Trust",
    trustText:
      "Building lasting relationships through transparency and integrity.",
    // propertyCategories
    luxuryTitle1: "Find Your",
    luxuryTitle2: "Luxury Property",
    categoryPenthouses: "Penthouses",
    categoryPenthousesCount: "15+ Properties",
    categoryPenthousesDesc: "Luxury living with stunning views",
    categoryVillas: "Villas",
    categoryVillasCount: "15+ Properties",
    categoryVillasDesc: "Spacious homes for families",
    categoryApartments: "Apartments",
    categoryApartmentsCount: "15+ Properties",
    categoryApartmentsDesc: "Modern urban living",
    categoryChalets: "Chalets",
    categoryChaletsCount: "15+ Properties",
    categoryChaletsDesc: "Beachfront luxury living",
    //featured properties
    featuredPropertiesTitle: "Featured Properties",
    featuredLabel: "Featured",
    locationLabel: "Location: ",
    projectLabel: "Project: ",
    unknown: "Unknown",
    totalPriceLabel: "Total Price",
    downPaymentLabel: "Down Payment",
    bedroomsLabel: "Bedrooms",
    bathroomsLabel: "Bathrooms",
    areaUnit: "m²",
    viewDetailsLabel: "View Details",
    noProjectsFound: "No projects found.",
    viewFeaturedPropertiesLabel: "View Featured Properties",
    // blogs
    articlesTitle: "Articles",
    noBlogPostsFound: "No blog posts found.",
    viewAllBlogs: "View All Blogs",
    readTimeUnit: "min read",
    readMore: "Read More",
    // أمثلة على مفاتيح الفئاتblogs
    categoryNews: "News",
    categoryTips: "Tips",
    categoryMarket: "Market Updates",
    categoryGuides: "Buying Guides",
    // hotoffers
    resaleLabel: "Resale",
    primaryLabel: "Primary",
    hotLabel: "Hot",
    offersLabel: "Offers",
    hotOffersDescription: "Exclusive deals and limited-time offers",
    residentialLabel: "Residential",
    commercialLabel: "Commercial",
    // featuredPropertiesTitle: "...",
    hotOfferLabel: "Hot Offer",
    oldPriceLabel: "Old Price",
    noOffersFound: "No offers found.",
    viewAllHotOffersLabel: "View Hot Offers",
    // developers
    featured_developers: "Our Featured Developers",
    discover_egypt:
      "Discover Egypt's leading real estate developers and their prestigious projects across the country.",
    projects: "Projects",
    units: "Properties",
    experience: "Experience",
    featured_projects: "Featured Projects",
    view_All_Developers:"View All Developers",
    no_developers: "No developers found.",
    no_projects: "No projects found.",
    new_launch: "New Launches",
    best_seller: "Best Seller",
    coming_soon: "Coming Soon",
    by: "By",
    // hero section
    DiscoverYourDreamHome: "Discover Your Dream Home",
    oflive: "oflive",
    FindYourPerfectProperty:
      "Find your perfect property in the most prestigious locations",
    add_unit: "Add your unit with us for sale",
    contact_us: "Contact Us",
    trusted_developers: "Our Trusted Developers",
    hot: "Hot",
    offers: "Offers",
    Resale: "Resale",
    Primary: "Primary",
    Buy: "Buy",
    Rent: "Rent",
    Addyourunitwithusforsale: "Add your unit with us for sale",
    propertyType: "PropertyType",
    selectType: "Select Type",
    hot_Description: "Exclusive deals and limited-time offers",
    

    selectArea: "Select Area",
    budgetRange: "Budget Range",
    browse: "Browse",
    // /blogs
    latestNews: "Latest News",
    subheading: "Discover our latest updates and articles.",
    readmore: "Read more",
    noPosts: "No posts available at the moment",
    allPosts: "All Posts",
    marketUpdates: "Market Updates",
    market_updates: "Market Updates",
    investmentTips: "Investment Tips",
    investment_tips: "Investment Tips",
    propertyGuides: "Property Guides",
    property_guides: "Property Guides",
    lifestyle: "Lifestyle",
    min: "min",
    //blog details
    description: "Description",
    //modal add unit
    addYourUnit: "Add Your Unit",
    quickSales: "Quick Sales",
    normalSales: "Normal Sales",
    quickSalesSubtitle: "Quick Sales (Less than 1 month)",
    name: "Name",
    mobileNumber: "Mobile Number",
    email: "Email",
    form_city: "City *",
    form_area: "Area *",
    form_project: "Project *",
    form_propertyType: "Property Type *",
    location: "Location",
    area: "Area",
    project: "Project",
    price: "Price",
    priceTag: "Low price or Zero over",
    minTotalPrice: "Min Total Price",
    downPayment: "Down Payment",
    notes: "Notes",
    submit: "Submit Request",
    close: "Close",
    selectLocation: "Select Location",
    country: "Country",
    select_area: "Select Area",
    propertyStatus: "Property Status",
    propertyIntent: "Property Intent",
    // selectArea: "Select Area",
    selectProject: "Select Project",
    selectCountry: "Select Country",
    selectPropertyType: "Select Property Type",
    //cotact us modale
    message: "Message",
    sendMessage: "Send Message",
    // share pop up icons
    shareThisProperty: "Share This Property",
    shareViaEmail: "Share Via Email",
    //  calls modal
    cancel: "Cancel",
    sendEmail: "Send Email",
    callNow: "Call Now",
    phoneNumber: "Phone Number",
    // property browser
    filters: "Filters",
    resetAll: "Reset All",
    applyFilters: "Apply Filters",
    priceRange: "Price Range",
    minPrice: "Minimum Price",
    maxPrice: "Maximum Price",
    areaRange: "Area Range",
    minArea: "Minimum Area",
    maxArea: "Maximum Area",
    // propertyType: "Property Type",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    studio: "Studio",
    oneBedroom: "1 Bedroom",
    twoBedrooms: "2 Bedrooms",
    threeBedrooms: "3 Bedrooms",
    fourPlusBedrooms: "4+ Bedrooms",
    developer: "Developer",
    currency: "Currency",
    paymentPlan: "Payment Plan",
    cash: "Cash",
    installments: "Installments",
    all: "All",
    reduced: "Reduced",
    hotOffer: "Hot Offer",
    luxury1: "Luxury",
    city: "City",

    priceReduced: "Price Reduced",
    Reduced: "Reduced ↓↓", 
    apartment: "Apartment",
    villa: "Villa",
    office: "Office",
    commercial: "Commercial",
    residential: "Residential",
    forSale: "For Sale",
    in: "in",
    bed: "Bed",
    beds: "Beds",
    bath: "Bath",
    baths: "Baths",
    m2: "m²",
    save: "Save",
    viewDetails: "View Details",
    noProperties: "No properties found matching your criteria.",
    whatsappMessage: "I'm interested in",
    features: "Features",
    locations: "Locations",
    clearFilters: "Clear Filters",
    allDevelopers: "All Developers",
    allCurrencies: "All Currencies",
    pageNavigation: "Page Navigation",
    page: "Page",
    of: "of",
    withAmazingViews: "with amazing views",
    beautiful: "Beautiful",
    // property details
    showMore: "Show More",
    noDetailsFound: "No Details found",
    property: "Property",
    whatsApp: "WhatsApp",
    call: "Call",
    paymentDetails: "Payment Details",
    parkingSpots: "Parking Spots",
    amenities: "Amenities",
    contactAgent: "Contact Agent",
    contactAgentDiscription: "Get in touch with our real estate expert",
    quickContact: "Quick Contact",
    yourName : "Your Name *",
    yourPhone: "Your Phone *",
    yourMessage: "Your Message",
    successMassage: "Message sent successfully!",
    contactAgentEndMassage:
      "Your information is safe with us. We'll never share your details with third parties.",
    monthlyInstallment: "Monthly Installment",
    //contact us error massages
    "error.requiredName": "Name is required",
    "error.nameOnlyLetters": "Name must only contain letters and spaces",
    "error.requiredPhone": "Mobile number is required",
    "error.phoneDigitsOnly": "Phone number must contain digits only",
    "error.invalidPhone": "Enter a valid mobile number",
    "error.invalidEmail": "Enter a valid email address",
    //add unit modal [quick sale] add
    "error.requiredLocation": "Location is required",
    "error.requiredArea": "Area is required",
    "error.requiredPropertyType": "Property Type is required",
    "error.requiredMinTotalPrice": "Min Total Price is required",
    "error.minTotalPricePositiveOnly": "Min Total Price must be positive",
    "error.minTotalPriceNumberOnly": "Min Total Price must be a number",
    "error.minTotalPriceMaxDigits": "Min Total Price must be at most 11 digits",
    "error.requiredDownPayment": "Down Payment is required",
    "error.downPaymentPositiveOnly": "Down Payment must be positive",
    "error.downPaymentNumberOnly": "Down Payment must be a number",
    "error.downPaymentMaxDigits": "Down Payment must be at most 11 digits",
    // normal sale add
    "error.requiredPrice": "Price is required",
    "error.pricePositiveOnly": "Price must be positive",
    "error.priceNumberOnly": "Price must be a number",
    "error.priceMaxDigits": "Price must be at most 11 digits",
    // newsletter modal add
    "error.requiredEmail": "Email is required",
    //property browser currency
    EGP: "Egyptian Pound",
    USD: "US Dollar",
    EUR: "Euro",
    SAR: "Saudi Riyal",
    AED: "UAE Dirham",
    KWD: "Kuwaiti Dinar",
  },
  ar: {
    // header$footer
    selectCurrency: "اختر العملة",
    selectOption: "اختر...",
    propertyImages: "صور العقار",
    home: "الرئيسية",
    hotOffers: "عروض ساخنة",
    featured: "عقارات مميزة",
    luxury: "عقارات فاخرة",
    luxury1: "عقار فاخر",
    articles: "مقالات",
    toggleLang: "EN",
    properties: "العقارات",
    developers: "المطورين",
    contactUs: "اتصل بنا",
    companyInfo: "معلومات الشركة",
    quickLinks: "روابط سريعة",
    newsletter: "النشرة الإخبارية",
    yourEmail: "البريد الإلكتروني الخاص بك",
    subscribe: "اشترك",
    allRightsReserved:"العقارات. جميع الحقوق محفوظة.",
    address: "التجمع الخامس،التسعين الشمالي",
    poweredBy: "مدعوم من",
    newsLetterDescription:
      " اشترك في النشرة الاخباريه للحصول علي التحديثات والعروض الحصريه ",
    footerDescription:
      "الشريك الموثوق لمساعدتك في العثور علي العقار المثالي في أرقي مواقع مصر",
    aboutTitle: "قيمنا ورسالتنا",
    aboutDescription:
      "نحن ملتزمون بتحويل تجربة الوساطة العقارية من خلال ربط العملاء بالعقارات والفرص المتميزة التي تتماشى مع أحلامهم وأهدافهم. مدفوعون بالنزاهة، نبني الثقة من خلال الشفافية والصدق والمساءلة في كل معاملة.",
    propertiesCount: "عقار",
    clientsCount: "عميل",
    excellenceTitle: "التميّز",
    excellenceText: "تقديم خدمة استثنائية وعقارات فاخرة تتجاوز التوقعات.",
    trustTitle: "الثقة",
    trustText: "بناء علاقات دائمة من خلال الشفافية والنزاهة.",
    luxuryTitle1: "ابحث عن",
    luxuryTitle2: "العقار الفاخر",
    categoryPenthouses: "بنتهاوس",
    categoryPenthousesCount: "أكثر من 15 عقارًا",
    categoryPenthousesDesc: "معيشة فاخرة بإطلالات خلابة",
    categoryVillas: "فلل",
    categoryVillasCount: "أكثر من 15 عقارًا",
    categoryVillasDesc: "منازل واسعة للعائلات",
    categoryApartments: "شقق",
    categoryApartmentsCount: "أكثر من 15 عقارًا",
    categoryApartmentsDesc: "حياة حضرية عصرية",
    categoryChalets: "شاليهات",
    categoryChaletsCount: "أكثر من 15 عقارًا",
    categoryChaletsDesc: "معيشة فاخرة على الشاطئ",
    // featured properties
    featuredPropertiesTitle: "العقارات المميزة",
    featuredLabel: "مميز",
    featured1: "عقار مميز",
    locationLabel: "الموقع: ",
    form_city: "مدينة *",
    form_area: "منطقة *",
    form_project: "مشروع *",
    form_propertyType: "نوع العقار *",
    projectLabel: "المشروع: ",
    unknown: "غير معروف",
    totalPriceLabel: "السعر الإجمالي",
    downPaymentLabel: "الدفعة المقدمة",
    bedroomsLabel: "غرف النوم",
    bathroomsLabel: "الحمامات",
    areaUnit: "م²",
    viewDetailsLabel: "عرض التفاصيل",
    noProjectsFound: "لا توجد مشاريع.",
    viewFeaturedPropertiesLabel: "عرض العقارات المميزة",
    // blogs
    articlesTitle: "المقالات",
    noBlogPostsFound: "لا توجد تدوينات.",
    viewAllBlogs: "عرض جميع المقالات",
    readTimeUnit: "  دقيقه قراءة",
    readMore: "اقرأ المزيد",
    // ترجمة الفئاتblogs
    categoryNews: "أخبار",
    categoryTips: "نصائح",
    categoryMarket: "تحديثات السوق",
    categoryGuides: "دلائل الشراء",
    //  hotoffers
    resaleLabel: "إعادة بيع",
    primaryLabel: "أساسي",
    hotLabel: "عروض",
    offersLabel: "مميزة",
    hotOffersDescription: "عروض حصرية ولفترة محدودة",
    residentialLabel: "سكني",
    commercialLabel: "تجاري",
    propertyStatus: "حالة العقار",
    propertyIntent: "وضع العقار",
    // featuredPropertiesTitle: "...", // من مثال سابق
    hotOfferLabel: "عرض مميز",
    oldPriceLabel: "السعر القديم",
    noOffersFound: "لا توجد عروض.",
    viewAllHotOffersLabel: "عرض العروض المميزة",
    //developers

    featured_developers: "المطورون المميزون",
    discover_egypt:
      "اكتشف أبرز مطوري العقارات في مصر ومشاريعهم المرموقة المنتشرة في جميع أنحاء البلاد.",
    projects: "مشروعات",
    units: "وحدات",
    experience: "الخبرة",
    featured_projects: "المشروعات المميزة",
    view_All_Developers:"عرض جميع المطورين",
    no_developers: "لم يتم العثور على مطورين.",
    no_projects: "لم يتم العثور على مشروعات.",
    by: "بواسطة",
    new_launch: "إطلاقات جديدة",
    best_seller: "الأكثر مبيعًا",
    coming_soon: "قريباً",
    //hero section
    DiscoverYourDreamHome: "اكتشف منزل أحلامك",
    FindYourPerfectProperty:
      "اعثر على العقار المثالي في أرقى المواقع",
    Resale: "إعادة البيع",
    Primary: "أساسي",
    Buy: "شراء",
    Rent: "إيجار",
    Addyourunitwithusforsale: "أضف وحدتك معنا للبيع",
    contact_us: "اتصل بنا",
    oflive: "الحياة ",
    country: "البلد",
    selectCountry: "اختر البلد",
    city: "المدينة",
    trusted_developers: "المطورون الموثوق بهم",
    hot: "عروض",
    offers: "ساخنة",
    propertyType: "نوع العقار",
    selectType: "اختر نوع العقار",

    selectArea: "اختر المساحه",
    budgetRange: "الميزانية المتاحة",
    browse: "تصفح",
    selectCity: "اختر المدينة",
    hot_Description: "عروض حصرية وعروض لفترة محدودة",
    // /blog
    latestNews: "آخر الأخبار",
    subheading: "اكتشف أحدث مقالاتنا وتحديثاتنا.",
    readmore: "اقرأ المزيد",
    noPosts: "لا توجد منشورات حالياً",
    allPosts: "كل المقالات",
    marketUpdates: "تحديثات السوق",
    investmentTips: "نصائح الاستثمار",
    propertyGuides: "أدلة العقارات",
    property_guides: "أدلة العقارات",
    investment_tips: "نصائح الاستثمار",
    market_updates: "تحديثات السوق", 
    lifestyle: "نمط الحياة",
    // readMore: "اقرأ المزيد",
    min: "دقيقة",
    //blog deatails
    description: "الوصف",
    //model add unit
    quickSales: "بيع سريع",
    addYourUnit: "اضف وحدتك",
    normalSales: "بيع عادي",
    quickSalesSubtitle: "بيع سريع (أقل من شهر)",
    name: "الاسم",
    mobileNumber: "رقم الموبايل",
    email: "البريد الإلكتروني",
    location: "الموقع",
    area: "المنطقة",
    project: "المشروع",

    price: "السعر",
    priceTag: "سعر منخفض",
    minTotalPrice: "الحد الأدنى للسعر الكلي",

    downPayment: "المقدم",
    notes: "ملاحظات",
    submit: "إرسال",
    close: "إغلاق",
    selectLocation: "اختر الموقع",
    select_area: "اختر المنطقة",
    selectProject: "اختر المشروع",
    selectPropertyType: "اختر نوع الوحدة",
    //contact us modal
    message: "الرساله",
    sendMessage: "إرسال رسالة",
    // share pop up icons
    shareThisProperty: "شارك هذه الخاصيه ",
    shareViaEmail: "شارك عن طريق الايميل",
    //CALL US MODAL
    cancel: "إلغاء",
    sendEmail: "ارسل بريدا",
    callNow: "اتصل الآن",
    phoneNumber: "رقم التليفون",
    // property browser
    filters: "الفلاتر",
    resetAll: "إعادة ضبط الكل",
    applyFilters: "تطبيق الفلاتر",
    priceRange: "نطاق السعر",
    minPrice: "السعر الأدنى",
    maxPrice: "السعر الأقصى",
    areaRange: "نطاق المساحة",
    minArea: "المساحة الأدنى",
    maxArea: "المساحة الأقصى",
    // propertyType: "نوع العقار",
    bedrooms: "غرف النوم",
    bathrooms: "الحمّامات",
    studio: "ستوديو",
    oneBedroom: "غرفة واحدة",
    twoBedrooms: "غرفتان",
    threeBedrooms: "ثلاث غرف",
    fourPlusBedrooms: "أربع غرف أو أكثر",
    developer: "مطور",
    currency: "العمله",

    paymentPlan: "خطة الدفع",
    cash: "نقداً",
    installments: "أقساط",
    all: "الكل",
    priceReduced: "سعر مخفض",
    Reduced: "مخفض ↓↓",
    hotOffer: "عرض ساخن",
    reduced: "سعر مخفض",
    apartment: "شقة",
    villa: "فيلا",
    office: "مكتب",
    commercial: "تجاري",
    residential: "سكني",
    forSale: "للبيع",
    in: "في",
    bed: "غرفة نوم",
    beds: "غرف نوم",
    bath: "حمام",
    baths: "حمامات",
    m2: "م²",
    save: "وفر",
    viewDetails: "عرض التفاصيل",
    noProperties: "لم يتم العثور على عقارات تطابق معاييرك.",
    whatsappMessage: "أنا مهتم بـ",
    features: "خصائص",
    locations: "مواقع",
    allDevelopers: "كل المطورين",
    clearFilters: "مسح الفلاتر",
    allCurrencies: "كل العملات",
    pageNavigation: "التنقل بين الصفحات",
    page: "الصفحه",
    of: "من",
    withAmazingViews: "بإطلالات رائعة",
    beautiful: "جميله",
    // propertydetails
    showMore: "عرض المزيد",
    noDetailsFound: "لا توجد تفاصيل",
    property: "خاصية",
    whatsApp: "واتساب",
    call: "اتصال",
    paymentDetails: "تفاصيل الدفع",
    parkingSpots: "أماكن ركن السيارات",
    amenities: "المرافق",
    contactAgent: "اتصل بالوكيل",
    contactAgentDiscription: "تواصل مع خبير العقارات لدينا ",
    quickContact: "تواصل سريع",
    yourName: "اسمك",
    yourPhone: "رقم هاتفك",
    yourMessage: "رسالتك",
    successMassage: "تم إرسال الرسالة بنجاح!",
    contactAgentEndMassage:
      "معلوماتك آمنة معنا. لن نشارك بياناتك مع أي طرف ثالث أبدًا.",
    monthlyInstallment:"قسط شهري",
    // contact us error massages
    "error.requiredName": "الاسم مطلوب",
    "error.nameOnlyLetters": "يجب أن يحتوي الاسم على حروف ومسافات فقط",
    "error.requiredPhone": "رقم الهاتف مطلوب",
    "error.phoneDigitsOnly": "يجب أن يحتوي رقم الهاتف على أرقام فقط",
    "error.invalidPhone": "من فضلك أدخل رقم هاتف صحيح",
    "error.invalidEmail": "من فضلك أدخل بريد إلكتروني صحيح",
    // add unit modal (quick sale) add
    "error.requiredLocation": "الموقع مطلوب",
    "error.requiredArea": "المنطقة مطلوبة",
    "error.requiredPropertyType": "نوع الملكية مطلوب ",
    "error.requiredMinTotalPrice": "الحد الأدني للسعر المطلوب",
    "error.minTotalPricePositiveOnly":
      "الحد الأدنى للسعر يجب أن يكون رقمًا موجبًا",
    "error.minTotalPriceNumberOnly": "الحد الأدنى للسعر يجب أن يكون رقمًا",
    "error.minTotalPriceMaxDigits":
      "الحد الأدنى للسعر يجب ألا يزيد عن 11 رقمًا",
    "error.requiredDownPayment": "المقدم مطلوب",
    "error.downPaymentPositiveOnly": "المقدم يجب ان يكون رقما موجبا",
    "error.downPaymentNumberOnly": "المقدم يجب ان يكون رقما ",
    "error.downPaymentMaxDigits": "المقدم يجب ألا يزيد عن 11 رقما",
    // normal sale add

    "error.requiredPrice": "الحد الأدني للسعر المطلوب",
    "error.pricePositiveOnly": "الحد الأدنى للسعر يجب أن يكون رقمًا موجبًا",
    "error.priceNumberOnly": "الحد الأدنى للسعر يجب أن يكون رقمًا",
    "error.priceMaxDigits": "الحد الأدنى للسعر يجب ألا يزيد عن 11 رقمًا",
    // newsletter modal add
    "error.requiredEmail": "البريد الاليكتروني مطلوب ",
    //property browser currency
    EGP: "الجنيه المصري",
    USD: "الدولار الأمريكي",
    EUR: "اليورو",
    SAR: "الريال السعودي",
    AED: "الدرهم الإماراتي",
    KWD: "الدينار الكويتي",
  },
};
